import { useUpdateMarkingFormData } from '@/shared/api'
import { zVat } from '@/shared/lib/zod'
import { useStringRecord } from '@/true-fsd/shared/utils/react'
import { ORDMarkingFormData } from '@synapex/prisma/client'
import { WorkspaceWithLinkDescriptor } from '@synapex/shared2/entities'
import { toast } from 'react-toastify'

const VAT_ERROR = '% НДС должен быть числом от 0 до 22'

const vatSchema = zVat({
    ['gte_-1']: VAT_ERROR,
    lte_22: VAT_ERROR,
    number: VAT_ERROR,
})

export function useVatInput(
    markingFormData: ORDMarkingFormData,
    wwld: WorkspaceWithLinkDescriptor,
    canEditVat: boolean
) {
    const errors = useStringRecord<{ vat: string }>()

    const updateMarkingFormData = useUpdateMarkingFormData(wwld, {
        mutationKey: ['mutation-update-marking-form-data'],
    })

    const onUpdateVatRate = (v: string) => {
        if (!canEditVat) return
        errors.clear('vat')
        const result = vatSchema.safeParse(v)

        if (result.success) {
            if (markingFormData.vat_percent !== result.data) {
                updateMarkingFormData.mutate({
                    vat_percent: result.data,
                })
            }
        } else {
            const errorMessage = result.error.issues[0].message
            errors.update(['vat', errorMessage])
            toast.error(errorMessage)
        }
    }

    return {
        onUpdateVatRate,
        vatError: errors.value.vat,
        clearVatError: () => errors.clear('vat'),
    }
}
